import { i18n } from '@/i18n-config';
import { AssetStoryblok } from '@/types/storyblok/storyblok-types';

export const returnTranslatedAlt = (altData: AssetStoryblok | string | undefined, language: string): string => {
    if (!altData) {
        return '';
    }

    if (typeof altData === 'string') {
        return altData;
    }

    const translatedAltKey = `AltText-${language.toUpperCase()}`;
    if (language !== i18n.defaultLocale && altData.meta_data && altData.meta_data[translatedAltKey]) {
        return altData.meta_data[translatedAltKey] || altData.alt;
    }
    return altData.alt;
};
